import { useCallback } from 'preact/hooks';

import cx from 'clsx';

import arrowRight from '@assets/icons/arrowRight.svg';
import InfoRed from '@assets/icons/infoExclamationRed.svg';

import Image from '../image/Image';
import { ISelectProps } from './Select.types';
import styles from './Select.module.scss';

const Select = ({
	options,
	wrapperClassName = '',
	label = '',
	className,
	name = '',
	value,
	onChange,
	disabled = false,
	showError = false,
	required = false,
	errorMessage,
}: ISelectProps) => {
	const renderOptionsList = () =>
		options?.map((opt) => (
			<option key={opt.id} value={opt.value} disabled={opt?.disabled ?? false}>
				{opt.label}
			</option>
		));

	const handleChange = useCallback(
		(event: Event) => {
			const target = event.target as HTMLSelectElement;
			if (onChange) {
				onChange(target.value, event);
			}
		},
		[onChange],
	);

	return (
		<div className={wrapperClassName}>
			{label && (
				<div className={cx('my2 lighter h6 lh6 dark3')}>
					{label} <span className="color-required">{required && ` *`}</span>
				</div>
			)}
			<div className="relative">
				<select
					className={cx(
						'h4 px4 lighter border-radius2 width100 border1 border-grey2 bg-white dark1 lh1',
						styles.selectField,
						className,
						{
							[styles.error]: showError,
						},
					)}
					name={name}
					value={value}
					onChange={handleChange}
					disabled={disabled}
					required
				>
					<option value="" disabled selected>
						Select an option
					</option>
					{renderOptionsList()}
				</select>
				<div className={cx('absolute', styles.arrowDownContainer)}>
					<Image
						src={arrowRight}
						alt="arrow"
						className={cx('pointer', styles.arrowDown)}
					/>
				</div>
			</div>
			<div
				className={cx(
					'h6 mt1 overflow-hidden d-flex justify-start items-start',
					styles.errorMessage,
					{
						[styles.show]: showError,
					},
				)}
				id="input-error-text"
			>
				{showError && (
					<Image src={InfoRed} alt={`${label} error`} className="mr1" />
				)}
				{showError && errorMessage}
			</div>
		</div>
	);
};

export default Select;
